<template>
    <div class="intro">

        <div class="container top-info">
            <h2><i class="el-icon-wind-power"/><span>活動名稱：</span>{{actInfo.name}}</h2>
            <div class="small"><i class="el-icon-date"/><span>活動日期：</span>{{actInfo.startAt}} 至 {{actInfo.endAt}}</div>
            <h2 class="addressWeb"><i class="el-icon-location-outline"/><span>活動地點：</span>{{showAddress}}</h2>

            <!--todo 形象圖-->
            <div class="oneBanner" v-show="isShowGraphImage(actInfo)">
                <img :src="actInfo.graphImageUrl" class="radius-pic">
            </div>

            <!--todo FB、IG、YT等連結-->
            <links :socialWebsites="websites" :socialWebsitesStatus="websiteStatus" :iconType="iconType" v-if="websiteStatus"/>

        </div>

        <category-header title="活動地點" class="mt-2 addressPhone"/>
        <div class="container text-content mb-4 addressPhone">{{showAddress}}</div>

        <template v-if="offersList.length > 0">
            <category-header :to="{name: 'TicketList', query:{p: ticketListParameter}}" title="搶券熱區" class="mt-4"/>
            <Ticket :list="offersList" :dataToken="ticketDataToken" :PreviewNum="9"/>
        </template>

        <template v-if="productList.length > 0">
            <category-header :to="getMoreProducts(productList)" title="熱銷商品" class="mt-4"/>
            <Product :list="productList" :PreviewNum="9" :key="productUpdate" @onItemClick="onProductClick"/>
        </template>

        <category-header title="活動介紹" class="mb-2 mt-4" v-show="isShowContent(actInfo)"/>
        <div ref="htmlContentContainer" class="container text-content mb-3" v-show="isShowContent(actInfo)" v-html="actInfo.content"/>

        <!--todo 輪播-->
        <div class="container" v-show="isShowBanner(bannerList)">
            <el-divider class="m-0"/>
            <!--橫圖加上樣式 isHorizontal -->
            <banner :list="bannerList" class="mt-4 mb-4 banner" :class="{'isHorizontal':isHorizontal}"/>
        </div>

        <!--todo YT嵌入-->
        <div class="container mt-4 mb-4" v-show="isShowVideo(videoUrl)">
            <el-divider/>
            <div class="video-container mt-4">
                <iframe id="act-video-frame" width="560" height="315" src="" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
            </div>
        </div>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import CategoryHeader from '@/components/category/Header'
    import Banner from "../../../components/BannerSlider";
    import Links from "./Links";
    import Ticket from "./SliderTicket";
    import Product from "./SliderProduct";

    import * as constDefine from '@/store/constDefine'
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"
    import Form from "@/util/form";

    export default {
        name: "IntroActivity",
        components: {
            CategoryHeader,
            Banner,
            Links,
            Toast,
            Ticket,
            Product,
        },
        props: {
            actInfo: { default: undefined }
        },
        watch: {
            //監聽，等到資料有變動再開始動作
            actInfo: function() {
                if (this.actInfo !== undefined) {
                    this.processScreenData();
                    if (this.isContainerRendered) {
                        this.handleContent();
                    }
                }
            },

            isContainerRendered: function () {
                if (this.isContainerRendered) {
                    if (this.isDataProcessed) {
                        this.handleContent();
                    }
                }
            }
        },
        computed: {
            isHorizontal: function () {
                if (this.$public.notNull(this.actInfo)) {
                    return this.actInfo.carouselType === 2;
                } else {
                    return false;
                }
            }
        },
        data() {
            return {
                shopAreaId: Number(this.$store.state.shopAreaInfo.id),   //商圈 id
                //活動id
                activityId: 0,
                //輪播
                bannerList: [],
                //店家推薦
                myAddStoreList: [],
                //搶券熱區
                offersList: [],
                ticketListParameter: "",
                ticketDataToken: "",
                removeSubscribe: {},
                // shoppingActInfo: {},       //活動資料
                //店家網頁連結
                mediaLinks: {
                    linkFb: '',
                    linkLine: '',
                    linkIg: '',
                    linkYoutube: '',
                    linkTwitter: '',
                    linkWebsite: '',
                    linkUbereats: '',
                    linkFoodpanda: '',
                    linkTiktok: '',
                },
                websites: '',
                websiteStatus: false,
                iconType: '', //社群連結Icon樣式

                videoUrl: '',           //影片連結
                showName: '',           //顯示用商圈名稱
                showCity: '',           //顯示用城市名稱
                showAddress: '',        //顯示用地址
                isLoading: false,
                lng: 0,
                lat: 0,
                productList: [
                    // { itemId: 1, name: "燒肉店商品禮券", titleImage: require('@/assets/images/img.png'), fee:'999' },
                    // { itemId: 2, name: "燒肉店商品禮券2", titleImage: require('@/assets/images/img.png'), fee:'999' },
                ],
                productUpdate: 0,

                isContainerRendered: false,
                isDataProcessed: false,
            }
        },
        created() {

        },
        mounted() {
            this.isContainerRendered = true;
            this.removeSubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type === "getOffersList") {
                    this.setupShoppingAreaActivityData(state.offersData)
                }
            })
        },

        methods: {
            // /** 取得GPS位置 */
            // getGpsLocation: function () {
            //     let self = this;
            //     return new Promise(function(resolve, reject) {
            //         let onSuccess = function (position) {
            //             self.lng = position.coords.longitude;
            //             self.lat = position.coords.latitude;
            //             // console.log(`getGpsLocation onSuccess: self.lng:${self.lng}, self.lat:${self.lat}`);
            //             //完畢
            //             resolve();
            //         };
            //
            //         let onError = function (error) {
            //             // reject("無法定位GPS");
            //             //注意這邊後續是否一定要用到 GPS，來決定要不要丟出錯誤
            //             //完畢
            //             resolve();
            //         };
            //
            //         self.$public.getGpsLocation(onSuccess, onError);
            //     });
            // },

            /** 處理一些顯示用的資料 */
            processScreenData: function () {
                // let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    if (self.$public.notNull(self.actInfo)){
                        //活動id
                        self.activityId = self.actInfo.id;
                        //搶券熱區
                        self.offersList = self.actInfo.offersList;

                        let obj = {
                            objectType: constDefine.MerchantType.ShoppingAreaActivity,
                            objectId: self.activityId,
                        }
                        self.ticketListParameter = self.$crypto.encryptObject(obj);
                        self.ticketDataToken = self.$crypto.objectToURIComponent(obj)

                        //顯示用的地址
                        self.showAddress = self.actInfo.city +self.actInfo.township +self.actInfo.address;

                        //輪播圖轉成首頁形式
                        if (self.$public.notNull(self.actInfo.photoImageUrlJsonStr) &&
                            self.actInfo.photoImageUrlJsonStr !== '') {

                            let photoList = self.actInfo.photoImageUrlJsonStr;
                            if (self.$public.notNull(photoList)) {
                                let bannerList = [];
                                photoList.forEach(
                                    (item) => {
                                        bannerList.push( self.transToHomeBanner(item)) ;
                                    }
                                )

                                self.bannerList = bannerList;
                            }
                        }

                        //處理影片
                        if (self.$public.notNull(self.actInfo.mediaUrl) &&
                            self.actInfo.mediaUrl !== '') {
                            self.changeVideoUrl(self.actInfo.mediaUrl);
                        }

                        self.websiteStatus = self.actInfo.websiteStatus===1?true:self.actInfo.websiteStatus===true?true:false;
                        //轉換店家網頁連結
                        if (self.$public.notNull(self.actInfo.websites) &&
                            self.actInfo.websites.length > 0) {
                            self.websites = JSON.stringify(self.actInfo.websites);

                            self.actInfo.websites.forEach(
                                (item) => {
                                    switch (item.type) {
                                        case constDefine.SITE_TYPE_FB:
                                            self.mediaLinks.linkFb = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_LINE:
                                            self.mediaLinks.linkLine = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_IG:
                                            self.mediaLinks.linkIg = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_YOUTUBE:
                                            self.mediaLinks.linkYoutube = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_TWITTER:
                                            self.mediaLinks.linkTwitter = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_WEBSITE:
                                            self.mediaLinks.linkWebsite = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_UBEREATS:
                                            self.mediaLinks.linkUbereats = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_FOODPANDA:
                                            self.mediaLinks.linkFoodpanda = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_TIKTOK:
                                            self.mediaLinks.linkTiktok = item.url;
                                            break;
                                    }
                                }
                            )
                        } else {
                            self.websiteStatus = false;
                            self.websites = '';
                        }

                        //熱銷商品 列表
                        self.productList = self.actInfo.cartList;
                        self.productUpdate++ ;
                    }
                    self.isDataProcessed = true;
                    //完畢
                    resolve();
                });
            },

            /** 將輪播圖轉成首頁輪播圖結構 */
            transToHomeBanner: function(photoItem) {
                if (this.$public.notNull(photoItem)) {
                    let newStruct = {
                        id: photoItem.id,
                        adParam: '',                //廣告參數
                        adType: 0,                  //廣告類型
                        imgUrl: photoItem.path,     //輪播圖
                        url: '',                    //點了以後要開啓的網頁
                    }
                    return newStruct;
                }
                return {};
            },

            /** 是否顯示輪播圖 */
            isShowBanner: function (banner) {
                return (this.$public.notNull(banner) && banner.length > 0)
            },

            /** 是否顯示活動介紹 */
            isShowContent: function (info) {
                return (this.$public.notNull(info.content) && info.content !== '')
            },

            /** 是否顯示單圖 */
            isShowGraphImage: function (info) {
                return (this.$public.notNull(info.graphImageUrl) && info.graphImageUrl !== '')
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                // let watchKey = 'watch?v=';
                // let video = 'https://www.youtube.com/embed/69arSuOXsRE?controls=0';
                // this.videoUrl = 'https://www.youtube.com/watch?v=v_RT8hLUDuo';
                // this.videoUrl = '<iframe width="560" height="315" src="'+ video +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>';

                if (this.$public.notNull(url) && url !== "") {
                    this.videoUrl = this.$public.getEmbedVideoUrl(url);
                    let frame = document.getElementById('act-video-frame');
                    if (this.$public.notNull(frame)) {
                        frame.src = this.videoUrl;
                    }
                }
            },

            /** 是否顯示影片 url */
            isShowVideo: function (videoUrl) {
                return (this.$public.notNull(videoUrl) && videoUrl !== "")
            },

            /** 是否顯示 "關於我們" */
            isShowAbout: function () {
                return (this.$public.notNull(this.shoppingAreaInfo.about) && this.shoppingAreaInfo.about !== "")
            },

            /** 開啓 url */
            onLinkClick: function (url) {
                let isCordova = !!window.cordova;
                if (isCordova) {
                    //開啓頁面
                    this.$public.openUrl(url);
                } else {
                    window.open(url);
                }
            },

            /** 點擊更多商品 */
            getMoreProducts: function (item) {
                let dataToken = this.cryptDataToken(JSON.stringify({ productList: item, shopAreaId: this.shopAreaId }));
                return {name: 'ProductList', query: {"dataToken": dataToken}} ;
            },

            /** 點擊 商品 */
            onProductClick: function (item) {
                let dataToken = this.cryptDataToken({"itemId": item.object.id, "shopAreaId": this.shopAreaId});
                this.$router.push({name: 'Product', query: {"dataToken": dataToken}});
            },

            setupShoppingAreaActivityData(offersData) {
                if (offersData.objectType > 0) {
                    this.$http.fetchWithEncrypt`GetShoppingAreaActivityOffersList${{
                        objectType: offersData.objectType,
                        objectId: offersData.objectId,
                    }} ${json => {
                        if (json.status) {
                            this.offersList = json.data.dataList;
                        }
                    }}`;
                }
            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },

            /** 解析 dataToken */
            decryptDataToken: function(item) {
                return this.$crypto.uriComponentToObject(item);
            },

            handleContent: function () {
                let self = this;

                self.$nextTick(() => {
                    Form.process(self.$refs.htmlContentContainer)
                })
            },
        },
        destroyed() {
            this.removeSubscribe();
        },
    }
</script>
<style lang="less" scoped src="../../../less/store.less"/>
<style lang="less" scoped src="../../../less/complex.less"/>